'use client';

import { useCallback, useEffect } from 'react';

import { useAuth } from '@/core/auth/client/AuthProvider';

import { CancelUnlimitResponse } from './interfaces';
import { useUrlParams } from './useUrlParams';

const cancelUnlimitTxn = async (params: { id: number; deposit_id: string }): Promise<CancelUnlimitResponse> => {
  try {
    const response = await fetch('/api/deposit/cancel-unlimit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });
    // eslint-disable-next-line @typescript-eslint/return-await
    return response.json();
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/return-await
    return { processed: false, message: 'Error al cancelar la transacción' };
  }
};

export const useUnlimitTransaction = () => {
  const { session } = useAuth();
  const { unlimit, unlimitGateway, unlimitTxn } = useUrlParams();

  const handleCancelUnlimit = useCallback(async () => {
    if (unlimit !== 'cancel' || unlimitGateway !== 'unlimit' || !unlimitTxn) return;

    if (session?.user?.id) {
      try {
        const response = await cancelUnlimitTxn({
          id: Number(session.user.id),
          deposit_id: unlimitTxn,
        });

        if (response.processed) {
          // eslint-disable-next-line no-console
          console.log(response.message);
        } else {
          // eslint-disable-next-line no-console
          console.log('Error al cancelar la transacción');
        }
      } catch (error) {
        console.warn('Error processing unlimit cancellation:', error);
      }
    }
  }, [unlimit, unlimitGateway, unlimitTxn, session?.user?.id]);

  useEffect(() => {
    handleCancelUnlimit();
  }, [handleCancelUnlimit]);

  return {
    handleCancelUnlimit,
  };
};
